// Routes owned by the Ticket module. Merged into the app-wide `paths` object
// by src/app/paths.ts; see src/modules/README.md.
export const ticketPaths = {
    ticket: '/tickets',
    ticketDetail: '/tickets/:id',
    ticketCreate: '/tickets/new',
    ticketEdit: '/tickets/:id/edit',
} as const
